import { render } from "./navigation.vue?vue&type=template&id=1c79e4b4&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"

import "./navigation.vue?vue&type=style&index=0&id=1c79e4b4&lang=scss&scoped=true"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c79e4b4"]])

export default __exports__